// 表头标体数据-报关单
const AEODec = {
// 报关单
    // 表头
    deHead:{
        id:'', // id
        customMaster:'', // 申报地海关
        // 申报状态
        seqNo:'', // 统一编号
        // 预录入编号
        // copName:'',  //录入单位名称
        entryNo:'', // 海关编号
        iePort:'', // 进境关别
        manualNo:'', // 备案号 
        contrNo:'', // 合同协议号
        ieDate:'', // 进口日期
        // 申报日期	
        // 境内收发货人 18位社会信用代码
        tradeCoScc:'',// 境内收发货人 海关编码
        tradeCode:'',// 境内收发货人 海关编码
        tradeCiqCode:'', // 境内收发货人 10位检验检疫编码
        tradeName:'', // 境内收发货人 企业名称（中文）
        overseasConsigneeCode:'', // 境外收发货人	代码
        overseasConsigneeEname:'', // 境外收发货人	企业名称（外文）
        ownerCodeScc:'', // 消费使用单位 18位社会信用代码
        ownerCode:'', // 消费使用单位 10位海关备案编码
        // 消费使用单位 10位检验检疫编码
        ownerName:'', // 消费使用单位 企业名称
        agentCodeScc:'913702205611551766', // 申报单位 18位社会信用代码
        agentCode:'37026800AT', // 申报单位 10位海关备案编码
            // 申报单位 10位检验检疫编码
        agentName:'青岛菲尔斯特物流有限公司', // 申报单位 企业名称
        trafMode:'', // 运输方式
        trafName:'', // 运输工具名称
        voyNo:'', // 航次号
        billNo:'', // 提运单号
        cutMode:'', // 征免性质
        licenseNo:'', // 许可证号
        tradeCountry:'', // 启运国(地区)
        distinatePort:'', // 经停港(目的港)
        transMode:'', // 成交方式
        feeMark:'', // 运费标志 1-运费率；2-运费单价；3-运费总价
        feeRate:'', // 运费／率
        feeCurr:'', // 运费币制
        insurMark:'', // 保险费 1-保费率；3-保费总价
        insurRate:'', // 保险费／率
        insurCurr:'', // 保险费币制
        otherMark:'', // 杂费  1-杂费率；3-杂费总价
        otherRate:'', // 杂费
        otherCurr:'', // 杂费币制
        packNo:'', // 件数
        wrapType:'', // 包装种类
        grossWet:'', // 毛重(KG)
        netWt:'', // 净重(KG)
        tradeAreaCode:'', // 贸易国别(地区)
        tradeMode:'', // 贸易方式/监管方式
            // 集装箱数
            // 随附单证
        entyPortCode:'',  // 入境口岸 代码6位或名称
        goodsPlace:'', // 货物存放地点
        entryType:'M', // 报关单类型
        noteS:'', // 备注	
        markNo:'N/M', // 标记唛码
        promiseItmes:'', // 价格说明
        purpOrgCode:'', // 目的地海关
            // 企业资质	两个输入框
        blNo:'',  // B/L号
        correlationNo:'', // 关联号码
        correlationReasonFlag:'', // 关联理由
            // 原箱运输	
        specDeclFlag:'',  // 特殊业务标识
        specDeclFlagText:'', // 显示特殊业务文字-自定义
            // 所需单证
        // declTrnRel:'', // 报关/转关关系标志
        ieFlag:'', // 进出口标志 "I”：进口。“E”：出口
        // inputerName:'', // 录入员名称
        // copCodeScc:'', // 录入单位18位代码
        tradeCoScc:'', // 收发货人统一编号18位
        // declareName:'', // 报关员名称
        // copCode:'',  // 录入单位代码
        // 备案清单
        billType:'', // 备案清单类型
        despPortCode:'',// 启运港
        despDate:'', // 启运日期
        origBoxFlag:'', // 原箱运输
        type:'', // 是否是备案清单，是的话写ML
        relId:'', // 关联报关单号
        relManNo:'', // 关联备案号
    },
    // 表头验证
    decHeadRules:{
        customMaster: [
            { required: true, message: '', trigger: 'change' }
        ],
        iePort: [
            { required: true, message: '', trigger: 'change' }
        ],
        tradeCoScc: [
            { required: true, message: '', trigger: 'blur' }
        ],
        tradeName: [
            { required: true, message: '', trigger: 'change' }
        ],
        ownerCodeScc: [
            { required: true, message: '', trigger: 'blur' }
        ],
        ownerName: [
            { required: true, message: '', trigger: 'change' }
        ],
        agentCodeScc: [
            { required: true, message: '', trigger: 'blur' }
        ],
        agentCode: [
            { required: true, message: '', trigger: 'blur' }
        ],
        agentName: [
            { required: true, message: '', trigger: 'change' }
        ],
        trafMode: [
            { required: true, message: '', trigger: 'change' }
        ],
        tradeMode: [
            { required: true, message: '', trigger: 'change' }
        ],
        tradeCountry: [
            { required: true, message: '', trigger: 'change' }
        ],
        distinatePort: [
            { required: true, message: '', trigger: 'change' }
        ],
        transMode: [
            { required: true, message: '', trigger: 'change' }
        ],
        packNo: [
            { required: true, message: '', trigger: 'blur' }
        ],
        wrapType: [
            { required: true, message: '', trigger: 'change' }
        ],
        grossWet: [
            { required: true, message: '', trigger: 'blur' }
        ],
        netWt: [
            { required: true, message: '', trigger: 'blur' }
        ],
        tradeAreaCode: [
            { required: true, message: '', trigger: 'change' }
        ],
        entyPortCode: [
            { required: true, message: '', trigger: 'change' }
        ],
        entyPortCode: [
            { required: true, message: '', trigger: 'blur' }
        ],
        entryType: [
            { required: true, message: '', trigger: 'change' }
        ],
        ieDate: [
            { required: true, message: '', trigger: 'blur' }
        ],
    },
    // 表体
    decListItem:{
        gNo:1, // 商品序号
        contrItem:'', // 备案序号
        codeTs:'', // 商品编号
        ciqCode:'', // 监管类别名称代码
        ciqName:'', // 监管类别名称-自定义
        gName:'', // 商品名称
        gModel:'', // 商品规格、型号
        gQty:'', // 成交数量
        gUnit:'', // 成交计量单位 [0-9]{3}
        declPrice:'', // 申报单价
        declTotal:'', // 申报总价
        tradeCurr:'', // 成交币制
        firstQty:'', // 第一法定数量
        firstUnit:'', // 第一计量单位（法定单位）
        exgVersion:'', // 版本号
        exgNo:'', // 货号
        destinationCountry:'CHN', //  原产国  出口;进口 原产国
        secondQty:'', // 第二法定数量	
        secondUnit:'', // 第二计量单位
        originCountry:'', // 最终目的国(地区) 出口 ; 进口 原产国
        districtCode:'', // 境内目的地/境内货源地
        destCode:'', // 目的地代码
        origPlaceCode:'', // 原产地区代码
        dutyMode:'', // 征免方式
        stuff:'', // 成份/原料/组份
        prodValidDt:'', // 产品有效期
        prodQgp:'', // 产品保质期
        engManEntCnm:'', // 境外生产企业
        goodsSpec:'', // 检验检疫货物规格	
        goodsModel:'', // 货物型号
        goodsBrand:'', // 货物品牌
        prodBatchNo:'', // 生产批号
        mnufctrRegNo:'', // 生产单位注册号
        // produceDate:'', // 生产日期
        goodsAttr:'', // 货物属性代码
        goodsAttrText:'', // 货物属性文字-自定义
        // purpose:'', // 用途代码

    },
    // 表体验证
    decListItemRules:{
        codeTs: [
            { required: true, message: '', trigger: 'blur' }
        ],
        gName: [
            { required: true, message: '', trigger: 'blur' }
        ],
        gQty: [
            { required: true, message: '', trigger: 'blur' }
        ],
        gUnit: [
            { required: true, message: '', trigger: 'change' }
        ],
        declPrice: [
            { required: true, message: '', trigger: 'blur' }
        ],
        declTotal: [
            { required: true, message: '', trigger: 'blur' }
        ],
        tradeCurr: [
            { required: true, message: '', trigger: 'change' }
        ],
        firstQty: [
            { required: true, message: '', trigger: 'blur' }
        ],
        destinationCountry: [
            { required: true, message: '', trigger: 'change' }
        ],
        origPlaceCode: [
            { required: true, message: '', trigger: 'change' }
        ],
        districtCode: [
            { required: true, message: '', trigger: 'change' }
        ],
        dutyMode: [
            { required: true, message: '', trigger: 'change' }
        ],
        originCountry:[
            { required: true, message: '', trigger: 'change' }
        ]
    },
    // 集装箱
    decContainer:{
        containerId:'', // 集装箱号
        containerMd:'', // 集装箱规格
        containerWt:'',// 自重
        lclFlag:'',// 拼箱标识
        goodsNo:'', // 商品项号
        // 自定义序号
        containerNum:1,
    },
    decContainerRules:{
        containerId: [
            { required: true, message: '', trigger: 'blur' }
        ],
        containerMd: [
            { required: true, message: '', trigger: 'change' }
        ],
        goodsNo:[
            { required: true, message: '', trigger: 'blur' }
        ],
    },
    // 随附单证
    decLicenseDocus:{
        docuCode:'', // 单证代码
        certCode:'', // 单证编号
        // 自定义序号
        licenseNum:1,
    },
    decLicenseDocusRules:{
        docuCode:[
            { required: true, message: '', trigger: 'blur' }
        ],
    },


    // 保税核注
    // 表头
    invtHeadType:{
        id:'',
        invtType:'', //清单类型
        putrecNo:'', // 账册编号，备案编号
        bizopEtpsNo:'', // 经营单位编码
        bizopEtpsSccd:'', // 经营单位社会信用代码	
        bizopEtpsNm:'', // 经营单位名称	
        rcvgdEtpsNo:'',  // 加工单位编码
        rvsngdEtpsSccd:'',  // 加工单位社会信用代码	
        rcvgdEtpsNm:'', // 加工单位名称
        dclEtpsNo:'37026800AT', // 申报单位编码
        dclEtpsSccd:'913702205611551766', // 申报单位社会信用代码	
        dclEtpsNm:'青岛菲尔斯特物流有限公司', // 申报单位名称
        inputCode:'37026800AT', // 录入单位编码
        inputCreditCode:'913702205611551766', // 录入单位社会信用代码	
        inputName:'青岛菲尔斯特物流有限公司', // 录入单位名称
        etpsInnerInvtNo:'',// 企业内部编号
        dclTypecd:'1', // 申报类型
        inputTime:'', // 录入日期
        invtDclTime:'', // 清单申报时间
        mtpckEndprdMarkcd:'', // 料件、成品标志
        supvModecd:'', // 监管方式
        trspModecd:'', //运输方式
        impexpPortcd:'', // 进出境关别
        dclPlcCuscd:'', // 主管海关,申报地区代码
        vrfdedMarkcd:'', // 核扣标记代码,	系统自动反填
        stshipTrsarvNatcd:'', //  启运国(地区)/运抵国(地区)
        invtIochkptStucd:'',// 清单进出卡口状态代码 系统自动反填
        applyNo:'', // 申请表编号/申报表编号
        listType:'', //流转类型	
        dclcusFlag:'', // 报关标志 是否
        genDecFlag:'2', // 是否生成报关单
        decType:'', //报关单类型
        dclcusTypecd:'', // 报关类型代码
        entryNo:'', //对应报关单编号
        corrEntryDclEtpsNo:'', // 对应报关单申报单位代码
        corrEntryDclEtpsSccd:'', // 对应报关单申报单位社会信用代码
        corrEntryDclEtpsNm:'', // 对应报关单申报单位名称
        rltEntryNo:'',// 关联报关单编号
        rltInvtNo:'', //关联清单编号
        rltPutrecNo:'', // 	关联手（账）册备案编号
        rltEntryBizopEtpsno:'', // 关联报关单境内收发货人编号
        rltEntryBizopEtpsSccd:'', // 关联报关单境内收发货人社会信用代码
        rltEntryBizopEtpsNm:'', // 关联报关单境内收发货人名称
        rltEntryRcvgdEtpsno:'', // 关联报关单生产销售(消费使用)单位编码
        rltEntryRvsngdEtpsSccd:'', // 关联报关单生产销售(消费使用)单位社会统一信用代码
        rltEntryRcvgdEtpsNm:'', // 关联报关单生产销售(消费使用)单位名称
        rltEntryDclEtpsno:'', // 关联报关单海关申报单位编码
        rltEntryDclEtpsSccd:'', // 关联报关单申报单位社会统一信用代码
        rltEntryDclEtpsNm:'', // 关关联报关单申报单位名称
        entryDclTime:'', // 报关单申报日期
        rmk:'', // 备注
        seqNo:'', // 清单预录入统一编号 报关单统一编号	
        impexpMarkcd:'', // 进出口标记代码,I：进口,E：出口
        decRmk:'', // 报关单草稿(备注)
    },
    // 表头校验
    invtHeadTypeRules:{
        invtType:[
            { required: true, message: '', trigger: 'change' }
        ],
        putrecNo:[
            { required: true, message: '', trigger: 'blur' }
        ],
        bizopEtpsNo:[
            { required: true, message: '', trigger: 'blur' }
        ],
        bizopEtpsNm:[
            { required: true, message: '', trigger: 'blur' }
        ],
        rcvgdEtpsNo:[
            { required: true, message: '', trigger: 'blur' }
        ],
        rcvgdEtpsNm:[
            { required: true, message: '', trigger: 'blur' }
        ],
        dclEtpsNo:[
            { required: true, message: '', trigger: 'blur' }
        ],
        dclEtpsNm:[
            { required: true, message: '', trigger: 'blur' }
        ],
        mtpckEndprdMarkcd:[
            { required: true, message: '', trigger: 'change' }
        ],
        supvModecd:[
            { required: true, message: '', trigger: 'change' }
        ],
        trspModecd:[
            { required: true, message: '', trigger: 'change' }
        ],
        impexpPortcd:[
            { required: true, message: '', trigger: 'change' }
        ],
        dclPlcCuscd:[
            { required: true, message: '', trigger: 'change' }
        ],
        stshipTrsarvNatcd:[
            { required: true, message: '', trigger: 'change' }
        ],
        dclcusFlag:[
            { required: true, message: '', trigger: 'change' }
        ],
        genDecFlag:[
            { required: true, message: '', trigger: 'change' }
        ],
        dclcusTypecd:[
            { required: true, message: '', trigger: 'change' }
        ],
        rltEntryBizopEtpsno:[
            { required: true, message: '', trigger: 'blur' }
        ],
        rltEntryBizopEtpsNm:[
            { required: true, message: '', trigger: 'blur' }
        ],
        rltEntryRcvgdEtpsno:[
            { required: true, message: '', trigger: 'blur' }
        ],
        rltEntryBizopEtpsNm:[
            { required: true, message: '', trigger: 'blur' }
        ],
        rltEntryDclEtpsno:[
            { required: true, message: '', trigger: 'blur' }
        ],
        rltEntryDclEtpsNm:[
            { required: true, message: '', trigger: 'blur' }
        ],
        etpsInnerInvtNo:[
            { required: true, message: '', trigger: 'blur' }
        ]
    },
    // 表体
    invtListType:{
        gdsSeqNo:'1',// 商品序号
        putrecSeqNo:'',// 备案序号
        gdsMtNo:'',// 商品料号
        entryGdsSeqNo:'',// 报关单商品序号
        applyTbSeqno:'',// 申报表序号
        gdeCd:'',// 商品编码
        gdsNm:'',//  商品名称
        gdsSpcfModelDesc:'',// 商品规格型号
        dclCurr:'',// 币制
        dclUnit:'',// 申报计量单位
        lawfUnit:'',// 法定计量单位
        secdLawfUnit:'',// 法定第二计量单位
        dclUnitQty:'',// 申报数量
        lawfUnitQty:'',// 法定数量	
        secdLawfUnitQty:'',// 第二法定数量
        dclUprcAmt:'',// 企业申报单价
        dclTotalAmt:'',// 企业申报总价
        natcd:'',// 原产国(地区)
        wtSfval:'',// 重量比例因子
        fstSfval:'',// 第一比例因子
        secdSfval:'',// 第二比例因子
        grossWt:'',// 毛重
        netWt:'',// 净重
        destinationNat:'',// 最终目的国(地区)
        lvyrlfModecd:'',// 征免方式
        ucnsVemo:'',// 单耗版本号
        // 自动备案序号
        modfMark:'3',// 修改标志	
        clyMark:'0',// 危化品标志	
        param1:'',//  来源标识
        rmk:'',//  备注
    },
    // 表体校验
    invtListTypeRules:{
        gdsMtNo:[
            { required: true, message: '', trigger: 'blur' }
        ],
        gdeCd:[
            { required: true, message: '', trigger: 'blur' }
        ],
        gdsNm:[
            { required: true, message: '', trigger: 'blur' }
        ],
        gdsSpcfModelDesc:[
            { required: true, message: '', trigger: 'blur' }
        ],
        dclCurr:[
            { required: true, message: '', trigger: 'change' }
        ],
        dclUnit:[
            { required: true, message: '', trigger: 'change' }
        ],
        dclUnitQty:[
            { required: true, message: '', trigger: 'blur' }
        ],
        lawfUnitQty:[
            { required: true, message: '', trigger: 'blur' }
        ],
        dclUprcAmt:[
            { required: true, message: '', trigger: 'blur' }
        ],
        dclTotalAmt:[
            { required: true, message: '', trigger: 'blur' }
        ],
        natcd:[
            { required: true, message: '', trigger: 'change' }
        ],
        destinationNat:[
            { required: true, message: '', trigger: 'change' }
        ],
        lvyrlfModecd:[
            { required: true, message: '', trigger: 'change' }
        ]
    },
    // 随附单证

}

export default AEODec